<template>
  <div
    class="dropdown absolute flex flex-col bg-white top-full text-left rounded-b-[4px] max-h-[216px] md:max-h-[320px] overflow-y-auto overflow-x-hidden z-10 shadow-lg border border-[#C3C2C1] no-scrollbar"
    :class="widthClasses"
  >
    <div v-if="options.length > 0">
      <div v-for="(option, index) in options" :key="index">
        <div
          @click="select(option)"
          :data-testid="`dropdown-option-${index + 1}`"
          class="w-full flex items-center py-3 md:py-4 pl-4 pr-4 justify-between cursor-pointer text-[1rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.5rem] md:leading-[2rem] lg:leading-[2.25rem] text-[#191817] border-t border-[#C3C2C1]"
          :class="
            getValue(option) == localValue
              ? 'bg-[#E5E2DF] text-black'
              : 'hover:bg-[#E7EDFE] hover:text-black'
          "
        >
          <span class="truncate">{{ labelField ? option[labelField] : option }}</span>

          <Tag v-if="manualLast && index === options.length - 1" :class="manualColorClass">
            Manual
          </Tag>
        </div>
      </div>
    </div>

    <div v-else :class="placeholderClasses">
      {{ noOptionsText }}
    </div>
  </div>
</template>

<script>
import HasOptions from '@/mixins/HasOptions';
import Tag from '@/components/design/Tag';

export default {
  components: {
    Tag,
  },

  mixins: [HasOptions],

  props: {
    widthClasses: {
      type: String,
      default: 'w-full left-0',
    },
    manualLast: {
      type: Boolean,
      default: false,
    },
    manualColorClass: {
      type: String,
      default: 'bg-[#D2DBFB] text-[#101010]',
    },
  },

  computed: {
    placeholderClasses() {
      return 'w-full flex items-center py-3 pl-4 pr-[27px] text-[1rem] leading-[1.5rem] text-[#191817] justify-between cursor-pointer hover:bg-[#E7EDFE] hover:text-black';
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
